import axios from "axios"
import baseURL from "../config/api"

export const post_SubGroup = (data: any, token: string) => {
    return axios({
        url: `${baseURL}subGroup`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const put_SubGroup = (data: any, token: string) => {
    return axios({
        url: `${baseURL}subGroup`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_SubGroup = (primaryKey: string, token: string) => {
    return axios({
        url: `${baseURL}subGroup`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: { id: primaryKey }
    }).then(response => response.data);
}

export const getSubGroupsByGroupId = (groupId: number, token: string) => {
    return getFetch(`subGroup/GetSubGroupsByGroupId/${groupId}`, token)
}

export const getSubGroups = (token: string) => {
    return getFetch("subGroup", token)
}

export const getSubGroup = (primaryKey: string, token: string) => {
    return getFetch(`subGroup/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}